<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div style="width: 100%; height: 100%">
        <!-- <dv-charts class="ring-charts" :option="option" /> -->
        <div style="line-height:1rem;text-align: center;padding:5px 20px;height: 8vh;">
          <div :style="{ 'color': 'white', 'font-size': '0.75rem', 'font-weight': 'bold' }">
            {{
              data['title'] }}
          </div>
        </div>
        <div class="bad-scroll" style="padding:1%;height:55vh;border-bottom: 1px solid white;">
          <table class="table-wrapper">
            <thead>
              <tr
                :style="{ 'background-color': '#072951', 'box-shadow': '-10px 0px 15px #2C58A6 inset,10px 0px 15px #2C58A6 inset', 'color': '' }">
                <th style="width:15%">发现日期</th>
                <th style="width:15%">计划完成</th>
                <th style="width:36%">内容</th>
                <th style="width:12%">负责人</th>
                <th style="width:12%">状态</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="data.issueList.length < 1">
                <td colspan="5">
                  <div style="text-align: center; margin: 20px;width: 100%;">
                    <h1 style="color: white; font-size: 20px">没有进行中的数据!</h1>
                  </div>
                </td>
              </tr>
              <template>
                <template v-for="(item, i) in data['issueList']">
                  <tr :key="i" @click="reportDetails(data, item.issueUUID)">
                    <td :style="{ 'color': timelyDate(item) ? 'red' : 'white' }">{{ formatDate(item.openDate)
                    }}</td>
                    <td :style="{ 'color': timelyDate(item) ? 'red' : 'white' }">
                      {{ formatDate(item.forecastedClosedDate) }}
                    </td>
                    <td><span v-html="item.desc" :style="{ 'color': timelyDate(item) ? 'red' : 'white' }"></span></td>
                    <td :style="{ 'color': timelyDate(item) ? 'red' : 'white' }">{{ item.owner }}</td>
                    <td :style="{ 'color': timelyDate(item) ? 'red' : 'white' }">{{ (item.status == 'G' ?
                      'Close' : 'Open') }}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <div style=";width: 100%; height:28vh" :id="data['id'] + 'bar'"></div>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import format from "date-fns/format";
import router from "../../../../router";
export default {
  name: "fr-issue-table",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
    updateTime: {
      type: Number,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      data: {
        issueList: []
      },
      current: {},
      option: {},
      refreshTime: null,
      dColor: '#00E690',
      issues: [],
      screen: 10,
      pageSize: 5,
      too: 10000,
    };
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        this.data = val;
        var _this = this;
        this.$nextTick(() => {
          _this.formatData();
        });

      },
      deep: true,
      immediate: true
    },
    updateTime: function (val, oldVal) {
      this.refreshTime = format(val, "HH:mm:ss");
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    timelyDate(item) {
      var now = new Date().setHours(0, 0, 0, 0) - 100;
      var closeDate = item['forecastedClosedDate'];
      if (closeDate && closeDate > 0 && item['status'] != 'G') {
        if (closeDate < now) {
          return true;
        }
        return false;
      }
      return false;
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy.MM.dd");
      }
      return "";
    },
    reportDetails(data, uuid) {
      this.$router.push({
        path: data.url,
        query: {
          key: uuid,
        },
      });
    },
    dataSlice(index, data) {
      var open = (index - 1) * this.pageSize;
      var end = index * this.pageSize;
      return data.slice(open, end);
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },

    formatData() {
      var data = this.data;
      var issueList = data['issueList'];
      this.screen = Math.ceil(issueList.length / this.pageSize);
      var barOpt = this.$echarts.init(
        document.getElementById(data["id"] + "bar")
      );

      var pieData = [];
      for (let f in data['deptData']) {
        pieData.push({ 'name': f, 'value': data['deptData'][f] });
      }

      var option = {
        title: {
          text: "部门分布",
          left: 0,
          textStyle: {
            color: "#ffffff",
            fontSize: this.fontSize(0.22),
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          show: true,
          orient: "vertical",
          textStyle: {
            color: "#fff",
            fontSize: this.fontSize(0.18),
          },
          left: "right",
          itemGap: 2,
          itemWidth: 10,
        },
        //  color: ["#09d0fb", "#91CC75", "#95f8fe", "#f9f390", "#ecfeb7"],
        color: ['#38EB70', '#F7E16C', '#0EFCFF', '#FD9133', '#4D92F2', "#0090ff", "#464aff", "#fad81f", "#ff605f"],
        series: [
          {
            type: "pie",
            radius: ["55%", "80%"],
            center: ["50%", "52%"],
            avoidLabelOverlap: true,
            data: pieData,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              normal: {
                formatter: '{b}:{c}',
                show: true,
                position: 'left',
                fontSize: this.fontSize(0.22),
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: this.fontSize(0.22),
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
          },
        ],
      };

      barOpt.setOption(option);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style>
.pagebg {
  background-size: 100%;
  background: url("../../../../assets/img/8dbg.png") center center / cover no-repeat;
}

.cred {
  color: red;
}

.cgreen {
  color: green;
}

.title {
  height: 30px;
  margin-bottom: 0px;
  font-weight: bold;
  text-indent: 20px;
  font-size: 0.45rem;
  text-align: center;
  align-items: center;
}

.table-wrapper>thead {
  position: sticky;
  top: 0;
}

.bad-scroll {
  overflow-y: auto;
  overflow-x: hidden;
}

.bad-scroll::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: yellow;
}

.bad-scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #EDEDED;
}
</style>
<style scoped src='./board.css'></style>




// WEBPACK FOOTER //
// src/pages/fr/groups/component/fr-issue-table.vue